module.exports = __webpack_public_path__ + "static/media/ic_minus.48fc2309.svg";